var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M38.6667 35V31.3333C38.6667 27.9163 36.3296 25.0451 33.1667 24.231M26.75 2.53306C29.4375 3.62093 31.3333 6.25574 31.3333 9.33333C31.3333 12.4109 29.4375 15.0457 26.75 16.1336M29.5 35C29.5 31.5831 29.5 29.8746 28.9418 28.527C28.1975 26.7301 26.7699 25.3025 24.973 24.5582C23.6254 24 21.9169 24 18.5 24H13C9.5831 24 7.87464 24 6.52699 24.5582C4.73012 25.3025 3.30251 26.7301 2.55822 28.527C2 29.8746 2 31.5831 2 35M23.0833 9.33333C23.0833 13.3834 19.8001 16.6667 15.75 16.6667C11.6999 16.6667 8.41667 13.3834 8.41667 9.33333C8.41667 5.28325 11.6999 2 15.75 2C19.8001 2 23.0833 5.28325 23.0833 9.33333Z",
    stroke: "#FCAF33",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.117d3acfdc717fbeb255b3e04f11f947.svg";
export { ForwardRef as ReactComponent };